// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3i2FE","colBig":"styles_colBig__KeAjx","colSmall":"styles_colSmall__3Rg-5","shopifyNameWrapper":"styles_shopifyNameWrapper__1I1EE"};